import script from "./TalentPool.vue?vue&type=script&setup=true&lang=js"
export * from "./TalentPool.vue?vue&type=script&setup=true&lang=js"

import "./TalentPool.vue?vue&type=style&index=0&id=35c7749e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35c7749e"]])

export default __exports__